import { AppliedConfigProvider } from "contexts/applied-config/AppliedConfigProvider";
import { SystemOverviewFiltersProvider } from "contexts/filters/system-overview-filters";
import { SystemOverviewLayout } from "layouts/OverviewLayout";

export const SystemOverviewPage = () => {
  return (
    <AppliedConfigProvider>
      <SystemOverviewFiltersProvider>
        <SystemOverviewLayout />
      </SystemOverviewFiltersProvider>
    </AppliedConfigProvider>
  );
};
